import * as angular from "angular";

let AdminFeaturesComponent = {
    selector: "vcAdminFeatures",
    templateUrl:
        "/angular/components/admin/dialogs/sections/admin-features.component.html",
    bindings: {
        features: "=",
    },
    controller: class AdminFeaturesController {
        // * bindings for typescript compiler *
        public features: any;
        // ************************************
    },
};

angular
    .module("admin")
    .component(AdminFeaturesComponent.selector, AdminFeaturesComponent);
